import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AnnouncementItemViewModel } from 'src/app/models/item.model';
import { SelectAttendanceAlertsEventPayload, SelectStudentEventPayload } from '../../models/event-payloads.model';
import { PublisherAvatarComponent } from '../publisher-avatar/publisher-avatar.component';

@Component({
  selector: 'app-announcement-publisher',
  templateUrl: './announcement-publisher.component.html',
  styleUrls: ['./announcement-publisher.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PublisherAvatarComponent]
})
export class AnnouncementPublisherComponent {
  @Input()
  item: AnnouncementItemViewModel;
  @Input()
  showPublisherLink: boolean;
  @Output()
  selectStudent = new EventEmitter<SelectStudentEventPayload>();
  @Output()
  selectAttendanceAlerts = new EventEmitter<SelectAttendanceAlertsEventPayload>();

  showStudent(event): void {
    event.stopPropagation();
    this.selectStudent.emit({
      studentId: this.item.student.id,
      schoolId: this.item.schoolId
    });
  }

  showAttendanceAlerts(event): void {
    event.stopPropagation();
    this.selectAttendanceAlerts.emit({
      studentId: this.item.student.id,
      schoolId: this.item.schoolId
    });
  }
}
